import React from 'react';

import styled from '@emotion/styled';

import TranslatingContainer from '../../../TranslatingContainer/TranslatingContainer';
import TranslatingContainerProvider from '../../../TranslatingContainer/TranslatingContainerProvider';
import ModalContainer from '../../ModalContainer';
import ComplaintStateWrapper from './ComplaintStateWrapper';
import ComplaintView from './ComplaintView';
import ComplaintViewAction from './ComplaintViewAction';
import ComplaintViewSubmissionForm from './ComplaintViewSubmissionForm';

interface AddressComplaintModalProps {
  data: any;
}

const AddressComplaintModal: React.FC<AddressComplaintModalProps> = ({
  data,
}) => {
  return (
    <ModalContainer label='Address Complaint'>
      <TranslatingContainerProvider>
        <ComplaintStateWrapper>
          <FormContainer>
            <TranslatingContainer>
              <ComplaintView data={data} />
              <ComplaintViewAction data={data} />
              <ComplaintViewSubmissionForm data={data} />
            </TranslatingContainer>
          </FormContainer>
        </ComplaintStateWrapper>
      </TranslatingContainerProvider>
    </ModalContainer>
  );
};

export default AddressComplaintModal;

const FormContainer = styled.div`
  display: flex;
  overflow: hidden;

  @media (max-width: 884px) {
    width: 100%;
  }
`;
